import type { NuxtMultiCacheRouteCacheHelper } from '/nuxt-multi-cache/helpers/RouteCacheHelper'

export function useCacheRoute(seconds: number = 300, callback?: (helper: NuxtMultiCacheRouteCacheHelper) => void) {
  const { query } = useRoute()
  useRouteCache((helper) => {
    if (!Object.keys(query).length)
      callback ? callback(helper) : helper.setCacheable().setMaxAge(seconds)
  })
}
